import { useEffect, useState } from "react";
import moment from "moment";

import ChangeValue from "./ChangeValue";
import Chart from "./Chart";
import SettingsChat from "./SettingsChat";
import Auth from "./Auth";

import { getStore } from "../funcs/main";

import "./Index.css";

const transportOptionsInitial = [
  { value: "Krone xx395252", label: "Krone xx395252" },
  { value: "Krone xx395999", label: "Krone xx395999" },
  { value: "Krone xx111111", label: "Krone xx111111" },
];

const initial = {
  accuracy: [5, 7],
  peak_accuracy: [5, 7],
  mintemp: [6, 0, 0],
  maxtemp: [7, 0.1, 0.1],
  maxpeaktemp: [15, 0, 0.1],
  random_coefficient: 0.1,
  period: 6,
  start_time: moment().subtract({ hours: 2 }).format("YYYY-MM-DDTHH:mm:ss"),
  stop_time: moment().format("YYYY-MM-DDTHH:mm:ss"),
  seconds_list: { 60: 1 },
};

export default function Index() {
  const [page, setPage] = useState("");

  const [changeValue, setChangeValue] = useState(0);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const [initialData, setInitialData] = useState([]);
  const [data, setData] = useState("");

  const [transportOptions, setTransportOptions] = useState(
    transportOptionsInitial
  );

  const [settings, setSettings] = useState({
    accuracy: [5, 7],
    peak_accuracy: [5, 7],
    mintemp: [6, 0, 0],
    maxtemp: [7, 0.1, 0.1],
    maxpeaktemp: [15, 0, 0.1],
    random_coefficient: 0.1,
    period: 6,
    start_time: moment().subtract({ hours: 2 }).format("YYYY-MM-DDTHH:mm:ss"),
    stop_time: moment().format("YYYY-MM-DDTHH:mm:ss"),
    seconds_list: { 60: 1 },
  });

  const [settingsChat, setSettingsChat] = useState({
    transport: "",
    sensor: "",
  });

  useEffect(() => {
    getData();
  }, [initialData]);

  useEffect(() => {
    if (!!selectedIndex) {
      setChangeValue(initialData[selectedIndex].Y);
    }
  }, [selectedIndex]);

  useEffect(() => {
    getDataForChart();
  }, []);

  async function getDataForChart() {
    let start_time = moment(settings.start_time).format("YYYY-MM-DD HH:mm:ss");
    let stop_time = moment(settings.stop_time).format("YYYY-MM-DD HH:mm:ss");
    let seconds_list = [60, 1];

    let response = await getStore(
      settings.accuracy,
      settings.peak_accuracy,
      start_time,
      stop_time,
      seconds_list,
      settings.mintemp,
      settings.maxtemp,
      settings.random_coefficient,
      settings.maxpeaktemp,
      Number(settings.period) * 60
    );

    if (response.length) {
      handleUpdatedData(response);
    }
  }

  async function handleInitial() {
    setSettings(initial);
    setTransportOptions(transportOptionsInitial);

    let start_time = moment(initial.start_time).format("YYYY-MM-DD HH:mm:ss");
    let stop_time = moment(initial.stop_time).format("YYYY-MM-DD HH:mm:ss");
    let seconds_list = [60, 1];

    let response = await getStore(
      initial.accuracy,
      initial.peak_accuracy,
      start_time,
      stop_time,
      seconds_list,
      initial.mintemp,
      initial.maxtemp,
      initial.random_coefficient,
      initial.maxpeaktemp,
      Number(initial.period) * 60
    );

    if (response.length) {
      handleUpdatedData(response);
    }
  }

  function getData() {
    let dataString = "";

    initialData.forEach((item) => {
      dataString = `${dataString}${item.X},${item.Y}\n`;
    });

    setData(dataString);
  }

  function handleUpdatedData(data) {
    let dataString = "";

    data.forEach((item) => {
      dataString = `${dataString}${item.X},${item.Y}\n`;
    });

    setData(dataString);
  }

  function handleChangeValue() {
    setInitialData(
      initialData.map((item, idx) => {
        if (idx === selectedIndex) {
          return { ...item, Y: changeValue };
        } else {
          return { ...item };
        }
      })
    );
    setSelectedIndex(0);
    setChangeValue(0);
  }

  function handleChangeDate(name, value) {
    if (name === "start") {
      setSettings({ ...settings, start_time: value });
    } else {
      setSettings({ ...settings, stop_time: value });
    }
  }

  function handleChangeSettings(name, value) {
    if (name === "sensor") {
      setSettingsChat({
        ...settingsChat,
        sensor: value,
      });
    } else {
      setSettingsChat({
        ...settingsChat,
        transport: value,
      });
    }
  }

  function handleChangeTransportName(value) {
    let updated = transportOptions.map((item) => item);

    updated[0].value = value;
    updated[0].label = value;

    setTransportOptions(updated);
  }

  return (
    <>
      {page === "" && <Auth setPage={setPage} />}

      {page === "main" && (
        <div className="chart">
          <ChangeValue
            value={changeValue}
            setValue={setChangeValue}
            handleChangeValue={handleChangeValue}
            handleUpdatedData={getDataForChart}
            handleInitial={handleInitial}
            data={settings}
            setData={setSettings}
            transport_name={transportOptions[0].value}
            handleChangeTransportName={handleChangeTransportName}
          />

          <div className="chart-col">
            <SettingsChat
              start_time={settings.start_time}
              stop_time={settings.stop_time}
              handleChangeDate={handleChangeDate}
              settingsChat={settingsChat}
              handleChangeSettings={handleChangeSettings}
              transportOptions={transportOptions}
            />

            <Chart
              data={data}
              setData={setData}
              setSelectedIndex={setSelectedIndex}
              mintemp={settings.mintemp[0]}
              maxtemp={settings.maxtemp[0]}
            />
          </div>
        </div>
      )}
    </>
  );
}
